var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"page-topbar"}},[_c('div',{staticClass:"navbar-brand-box"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/images/knot.svg"),"alt":"","height":"40"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }